<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main-tang">
          <div class="b-richtext">
            <p v-html="richText"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>

  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/";
import Nav from "@/components/nav/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/"
import Footer from "@/components/footer/"
import Contact from "@/components/contact/";
export default {
  data () {
    return {
      richText: '',
    };
  },
  mounted () {
    this.richText =
            '<p style="text-align: left; margin-left: 60px; margin-top: 60px; "><span style="font-size: 22px; border-bottom: solid 3px rgb(12, 92, 200);">唐仲英荣誉体系</span></p>'
            + '<p style="margin-left: 60px; margin-top: 40px;  margin-bottom: 40px; margin-right: 40px;"><span style="font-size: 16px; ">唐仲英荣誉体系，聚焦于转化医学领域，包括唐仲英首席科学家、唐仲英访问学者、 仲英青年学者、唐仲英学者计划。优先启动唐仲英首席科学家、唐仲英访问学者计划、优化仲英青年学者计划，并根据荣誉体系建设与推进情况，与唐仲英基金会共商适时启动“唐仲英学者计划”。</span></p>'

            + '<p style="margin-left: 60px; margin-top: 60px; margin-bottom: 40px;"><span style="font-size: 20px;border:20px solid rgb(12, 92, 200); background-color: rgb(12, 92, 200); border-radius: 7px; color: white;"> &nbsp;&nbsp;&nbsp;第一届首席科学家&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;  </span></p>'

      + '<div id="professor" style="width:100%; height:550px">'
            + '<div class="content" >'
              + '<div id="center" style="float:left ;  margin-top:15px; width:49%; height:100%;">'

              + '<p style="margin-left: 30px; margin-top:20px"><span style="font-size: 16px; font-weight: bold;">宁光  院士<br>' +
              '代谢与健康<br>' +
              '创新研究团队<br></span></p>'
              + '</div>'
              + '<div id="right" style="float:left ;  margin-top:15px; width:49%; height:100%;">'

              + '<p style="margin-left : 30px"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/pro_ng.png" style="float: center; width: 130px; " border="0" vspace="0" alt=""></p>'
              + '</div>'

              + '<div class="box">'
                + '<p style="margin-left: 20px; margin-right:20px;margin-bottom:0px "><span style="font-size: 15px;">该团队目标基于大规模具有代表性和全面性的中国人群队列研究，形成独立自主和高质量的中国人群特异性数据和研究体系，整合构建中国人的基因组，精细表型组等基线和随访数据库，构筑深度数据分析的研究体系，目标在疾病机制、药物开发、行为干预和数据解读等领域产生创新成果，形成中国标准。成为我国精准医学发展的重要基础，引领重大慢病的防治和药物的开发应用。</span></p>'

              + '</div>'
            + '</div>'

            + '<div class="content1" >'
              + '<div id="center" style="float:left ;  margin-top:15px; width:49%; height:100%;">'

              + '<p style="margin-left: 30px; margin-top:20px;"><span style="font-size: 16px;font-weight: bold;">樊春海 院士<br>' +
              '框架核酸设计<br>' +
              '与纳米医学诊疗<br></span></p>'
              + '</div>'
              + '<div id="right" style="float:left ;  margin-top:15px; width:49%; height:100%;">'

              + '<p style="margin-left : 30px"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/pro_fch.png" style="float: center; height: 142.58px; " border="0" vspace="0" alt=""></p>'
              + '</div>'

              + '<div class="box">'
              + '<p style="margin-left: 20px; margin-right:20px;margin-bottom:0px "><span style="font-size: 15px; ">团队基于核酸分子自组装、逻辑编程、材料复合、高时空分辨显微成像等技术，构建核酸分子机器与纳米机器人，为恶性肿瘤等重大疾病的早期检测和诊疗提供全新智能工具。发展了一系列基于框架核酸的诊断与治疗策略，展示了针对多尺度靶标的通用电化学检测平台、透皮药物递送、急性肾病治疗、循环肿瘤细胞捕获等应用原型。<br><br></span></p>'

              + '</div>'
            + '</div>'

            + '<div class="content1" >'
              + '<div id="center" style="float:left ;  margin-top:15px; width:49%; height:100%;">'

              + '<p style="margin-left: 30px; margin-top:20px;"><span style="font-size: 16px;font-weight: bold;">董晨 院士<br>' +
              '免疫调节<br>' +
              '与疾病创新团队<br></span></p>'
              + '</div>'
              + '<div id="right" style="float:left ;  margin-top:15px; width:49%; height:100%;">'

              + '<p style="margin-left : 30px"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/pro_dc.png" style="float: center; width: 130px; " border="0" vspace="0" alt=""></p>'
              + '</div>'

              + '<div class="box">'
              + '<p style="margin-left: 20px; margin-right:20px;margin-bottom:0px "><span style="font-size: 15px; ">该团队在前期对银屑病和强直性脊柱炎等治疗突破的基础上，聚焦于Th17和Tfh细胞相关的炎症调控机制的解析，从细胞、分子等多层面和多角度对炎症的发生、发展及调控进行全方位研究。深度阐析Th17和Tfh细胞在相关炎症反应中的功能和作用机理，并查明调控它们分化和功能的关键分子和相关机制，为自身免疫疾病的治疗提供重要的理论基础、新的治疗靶点和治疗策略。</span></p>'

              + '</div>'
            + '</div>'
      + '</div>'
      + '<p>&nbsp;</p>'

      + '<div id="left" style="float:left ; width:98%; height:100%;">'
      + '<p style="margin-left: 60px; margin-top: 20px; margin-bottom: 40px;"><span style="font-size: 20px;border:20px solid rgb(12, 92, 200); background-color: rgb(12, 92, 200); border-radius: 7px; color: white;"> &nbsp;&nbsp;&nbsp;仲英青年学者(2021)&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;&nbsp; </span></p>'
      + '</div>'

      + '<div id="scholar" style="width:100%; height:630px">'
        ///////// 第一排
        + '<div class="content" style="margin-left: 230px; width:30%; ">'
          + '<div id="center" style="float:left ;  margin-top:15px; width:95%; height:100%;">'

          + '<p style="margin-left: 30px; margin-top:20px;"><span style="font-size: 16px;font-weight: bold;">傅洛伊<br>' +
          '电子信息与电气工程学院<br></span></p>'
          + '</div>'

          + '<div class="box">'
          + '<p style="margin-left: 20px; margin-right:20px; ;margin-bottom:0px "><span style="font-size: 15px">致力于从事网络传输优化、数据挖掘及知识图谱等领域的基础理论和关键技术研究，聚焦信息传输的方法与机理，围绕网络连通部署、信息路径规划和传输速率优化开展研究。<br><br></span></p>'
          + '</div>'
        + '</div>'

        + '<div class="content1" style="width:30%; margin-right: 100px; ">'
          + '<div id="center" style="float:left ;  margin-top:15px; width:95%; height:100%;">'

          + '<p style="margin-left: 30px; margin-top:20px;"><span style="font-size: 16px;font-weight: bold;">张晨虹<br>' +
          '生命科学技术学院<br></span></p>'
          + '</div>'

          + '<div class="box">'
          + '<p style="margin-left: 20px; margin-right:20px;margin-bottom:0px "><span style="font-size: 15px; ">遵循科赫法则的微生物病原学逻辑框架和生态学原理，采用多变量统计学整合分析元基因组学、代谢组学数据，为建立系统识别影响肥胖、2型糖尿病乃至衰老的关键肠道细菌的研究策略做出重要贡献。</span></p>'

          + '</div>'
        + '</div>'

        ///////// 第二排
        + '<div class="content">'
          + '<div id="center" style="float:left ;  margin-top:15px; width:95%; height:100%;">'

          + '<p style="margin-left: 30px; margin-top:20px;"><span style="font-size: 16px;font-weight: bold;">刘  珅<br>' +
          '第六人民医院<br></span></p>'
          + '</div>'

          + '<div class="box">'
          + '<p style="margin-left: 20px; margin-right:20px;margin-bottom:0px "><span style="font-size: 15px; ">明确巨噬细胞介导AM导致炎症的机制；阐明ERK2通过SMAD3加重粘连的机制，并构建了敲低ERK2的抗增生AM；突破凝胶微流控技术瓶颈。<br><br></span></p>'
          + '</div>'
        + '</div>'

        + '<div class="content1">'
          + '<div id="center" style="float:left ;  margin-top:15px; width:95%; height:100%;">'

          + '<p style="margin-left: 30px; margin-top:20px;"><span style="font-size: 16px;font-weight: bold;">卢  敏<br>' +
          '瑞金医院<br></span></p>'
          + '</div>'

          + '<div class="box">'
          + '<p style="margin-left: 20px; margin-right:20px;margin-bottom:0px "><span style="font-size: 15px; ">获得p53靶向化合物的第一人。聚焦p53靶向治疗基础研究和转化研究约19年，生涯致力于获得First-in-class p53靶向药物“从0到1”提出抑癌蛋白靶向理论，进而获得一系列p53靶向化合物。</span></p>'

          + '</div>'
        + '</div>'

        + '<div class="content1">'
          + '<div id="center" style="float:left ;  margin-top:15px; width:95%; height:100%;">'

          + '<p style="margin-left: 30px; margin-top:20px;"><span style="font-size: 16px;font-weight: bold;">瞿叶高<br>' +
          '机械与动力工程学院<br></span></p>'
          + '</div>'

          + '<div class="box">'
          + '<p style="margin-left: 20px; margin-right:20px;margin-bottom:0px "><span style="font-size: 15px; ">动力学与控制研究。在结构与流体声场耦合动力学与控制方面取得创新研究成果。提出了能量变分一致的层合结构高精度理论模型，构建了高效的时域/频域区域分解-谱边界元理论方法。</span></p>'

          + '</div>'
        + '</div>'
      + '</div>'

      + '<p>&nbsp;</p>'+ '<p>&nbsp;</p>'+ '<p>&nbsp;</p>'+ '<p>&nbsp;</p>';

  },
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-footer": Footer,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss" scoped>
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
.b-richtext {
  text-align:left;
  margin-top: 0px;
  b,
  strong {
    font-weight: 700;
  }
  /*p {*/
  /*  margin: 0 0 0px;*/
  /*}*/
  line-height: 32px;
}
.b-radius {
  border: 3px solid rgb(204, 204, 204);
  border-radius: 100%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.content {
  float:left ;
  margin-left:60px;
  margin-top:15px;
  width:30%;
  //height:100%;
  //box-sizing: border-box;
  padding: 7px;
  border-radius: 46px;
  background-image: -webkit-linear-gradient(top, white,rgb(12, 92, 200));
  background-image: -moz-linear-gradient(top, white,rgb(12, 92, 200));
  background-image: linear-gradient(top, white,rgb(12, 92, 200));
}

.content1 {
  float:left ;
  margin-left:10px;
  margin-top:15px;
  width:30%;
  //height:100%;
  //box-sizing: border-box;
  padding: 7px;
  border-radius: 46px;
  background-image: -webkit-linear-gradient(top, white,rgb(12, 92, 200));
  background-image: -moz-linear-gradient(top, white,rgb(12, 92, 200));
  background-image: linear-gradient(top, white,rgb(12, 92, 200));
}

.box {
  width:100%;
  height:100%;
  border-radius: 46px;
  background:#fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/honor_system/index.vue